// Styles for the application root
import baseStyles from 'catena/er2_styles'
import breadcrumbsStyle from './breadcrumbs_subheader'
import buttonGroupStyle from './buttongroupstyle'
import collaborationStyle from './collaboration'
import ficusControlsStyle from './ficus_controls_style'
import ficusMapStyle from './ficus_map_style'
import ficusStyle from './ficus_style'
import globalStyle from './globals'
import instructionsStyle from './instructions'

const parentStyles = {
    ...baseStyles,
    ...globalStyle,
    root: {
        ...baseStyles.root,
    },
    controlBar: {
        ...baseStyles.controlBar,
        overflow: 'visible',
        zIndex: 300,
    },
    mapToolbarContainer: {
        ...baseStyles.mapToolbarContainer,
        zIndex: 300,
    },
    headerTextContent: {
        ...breadcrumbsStyle.headerTextContent,
        ...baseStyles.headerTextContent,
    },
    ...buttonGroupStyle,
    ...collaborationStyle,
    ...ficusControlsStyle,
    ...ficusMapStyle,
    ...ficusStyle,
    ...instructionsStyle,
}

export default parentStyles
